import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-unsupported-browser',
    templateUrl: './unsupported-browser.component.html',
    styleUrls: ['./unsupported-browser.component.scss']
})
export class UnsupportedBrowserComponent implements OnInit {
    @Output() hide = new EventEmitter<void>();

    constructor() { }

    ngOnInit() {
    }

    onContinue() {
        this.hide.emit();
    }
}
